import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { useTheme } from 'styled-components'
import { useTranslation } from 'react-i18next'
import getTheme from '../../../themes'
import { OsGrid } from '../../Instances/components/create-instance/configure/styles'
import { InfoContainer } from '../../../components/info-block/styles'
import { DarkForm } from '../../Load-balancers/create-page/pool-remembers/styles'
import { Actions, Fields, FieldRow, FormLayout, Summary } from './form-styles'
import { CreationMode } from './model'

export default function CreationSkeleton({ mode, step }: { mode: CreationMode; step: number }) {
  const theme = useTheme() as ReturnType<typeof getTheme>
  const [t] = useTranslation()
  const colors = { baseColor: theme.palette[300], highlightColor: theme.palette[20] }
  const field = (width = 110) => <div>
    <Skeleton {...colors} width={width} height={14} style={{ marginBottom: 8 }} />
    <Skeleton {...colors} height={40} borderRadius={8} />
  </div>

  return <FormLayout role="status" aria-label={String(t('LOADING'))} aria-busy="true" data-test-id="dedicated-create-skeleton">
    <Fields aria-hidden="true">
      <Skeleton {...colors} width="85%" height={16} />
      {step === 0 ? <>
        {mode === 'preorder' && field(130)}
        {field()}
        {mode === 'preorder' ? <>
          <FieldRow>{field(40)}{field(90)}</FieldRow>
          <FieldRow>{field(40)}{field(100)}</FieldRow>
          <InfoContainer customStyles={{ marginBottom: 0 }}>
            <Skeleton {...colors} width={85} height={20} />
            <Skeleton {...colors} width={120} height={40} style={{ marginTop: 10 }} />
            <DarkForm><div style={{ flex: 1 }}>{field(85)}</div></DarkForm>
          </InfoContainer>
        </> : <div>
          <Skeleton {...colors} height={30} style={{ marginBottom: 8 }} />
          <Skeleton {...colors} height={64} count={3} style={{ marginBottom: 8 }} borderRadius={8} />
        </div>}
        <div>
          <Skeleton {...colors} width={140} height={14} style={{ marginBottom: 20 }} />
          <OsGrid>{Array.from({ length: 6 }, (_, index) => <Skeleton key={index} {...colors} width={100} height={84} borderRadius={8} />)}</OsGrid>
        </div>
        {field(70)}
        {mode === 'preorder' && field(170)}
      </> : step === 1 ? <>{field(130)}{field(80)}</> : <Skeleton {...colors} height={320} borderRadius={8} />}
      <Actions>
        <Skeleton {...colors} width={110} height={40} borderRadius={8} />
        <Skeleton {...colors} width={90} height={40} borderRadius={8} />
      </Actions>
    </Fields>
    <Summary aria-hidden="true">
      <Fields>
        <Skeleton {...colors} width="85%" height={20} />
        {Array.from({ length: 5 }, (_, index) => <div key={index}>
          <Skeleton {...colors} width={70} height={14} style={{ marginBottom: 8 }} />
          <Skeleton {...colors} width="90%" height={18} />
        </div>)}
      </Fields>
    </Summary>
  </FormLayout>
}
